import { Typography } from '@material-ui/core'

import { useWindowDimensions } from '../../helpers/pageSize'
import { getTranslate } from '../../localization'
import useStyles from './styles/MonitoringReserveTableFixedTitles.styles'

type MonitoringReserveTableFixedTitlesProps = {
  accommodationsNames: string[]
}

export default function MonitoringReserveTableFixedTitles({
  accommodationsNames
}: MonitoringReserveTableFixedTitlesProps) {
  const classes = useStyles()
  const { width } = useWindowDimensions()

  return (
    <div className={classes.root}>
      <Typography variant="h3" className={classes.entityName}>
        {getTranslate('Entity Name')}
      </Typography>
      {accommodationsNames.map((accName, accIndex) => (
        <div
          className={[
            classes.accNameContainer,
            accIndex % 2 == 0 && classes.accNameContainerEven
          ].join(' ')}>
          <Typography
            className={[
              classes.accName,
              width < 1280
                ? classes.accName1280
                : width < 1440
                ? classes.accName1440
                : width < 1680
                ? classes.accName1680
                : ''
            ].join(' ')}>
            {accName}
          </Typography>
        </div>
      ))}
    </div>
  )
}
